{
  "actionbar.actions": "Műveletek",
  "actionbar.actionsAvailable": "Műveletek állnak rendelkezésre.",
  "actionbar.clearSelection": "Kijelölés törlése",
  "actionbar.selected": "{count, plural, =0 {Egy sincs kijelölve} other {# kijelölve}}",
  "actionbar.selectedAll": "Mind kijelölve",
  "breadcrumbs.more": "További elemek",
  "button.pending": "függőben levő",
  "calendar.invalidSelection": "A kijelölt {selectedCount, plural, one {dátum nem érhető el} other {dátumok nem érhetőek el}}.",
  "combobox.noResults": "Nincsenek találatok",
  "contextualhelp.help": "Súgó",
  "contextualhelp.info": "Információ",
  "datepicker.endTime": "Befejezés ideje",
  "datepicker.startTime": "Kezdés ideje",
  "datepicker.time": "Idő",
  "dialog.alert": "Figyelmeztetés",
  "dialog.dismiss": "Elutasítás",
  "dropzone.replaceMessage": "Ejtse le a fájlt a cseréhez",
  "inlinealert.informative": "Információ",
  "inlinealert.negative": "Hiba",
  "inlinealert.notice": "Figyelmeztetés",
  "inlinealert.positive": "Siker",
  "label.(optional)": "(opcionális)",
  "label.(required)": "(kötelező)",
  "menu.moreActions": "További lehetőségek",
  "menu.unavailable": "Nem érhető el, a részletekért bontsa ki",
  "notificationbadge.indicatorOnly": "Új tevékenység",
  "notificationbadge.plus": "{notifications}+",
  "picker.placeholder": "Kiválasztás…",
  "picker.selectedCount": "{count, plural, =0 {Nincs kijelölve elem} one {# elem kijelölve} other {# elem kijelölve}}",
  "slider.maximum": "Maximum",
  "slider.minimum": "Minimum",
  "table.cancel": "Mégse",
  "table.editCell": "Cella szerkesztése",
  "table.loading": "Betöltés folyamatban…",
  "table.loadingMore": "Továbbiak betöltése folyamatban…",
  "table.resizeColumn": "Oszlop átméretezése",
  "table.save": "Mentés",
  "table.sortAscending": "Növekvő rendezés",
  "table.sortDescending": "Csökkenő rendezés",
  "tag.actions": "Műveletek",
  "tag.hideButtonLabel": "Mutass kevesebbet",
  "tag.noTags": "Egyik sem",
  "tag.showAllButtonLabel": "Az összes megjelenítése ({tagCount, number})",
  "toast.clearAll": "Összes törlése",
  "toast.collapse": "Összecsukás",
  "toast.showAll": "Összes megjelenítése"
}
